var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { ContentTreeTemplateMutationtypes } from '@/types/content-tree-template';
import contentTreeTemplateApiClient from '@/plugins/apis/content-tree-template-api-client';
export var state = function () { return ({
    content_tree_templates: []
}); };
export var getters = {
    contentTreeTemplates: function (state) {
        return state.content_tree_templates;
    }
};
export var mutations = (_a = {},
    _a[ContentTreeTemplateMutationtypes.INIT_STATE] = function (state, payload) {
        Object.assign(state, payload);
    },
    _a[ContentTreeTemplateMutationtypes.FETCH_CONTENT_TREE_TEMPLATES] = function (state, payload) {
        state.content_tree_templates = payload;
    },
    _a[ContentTreeTemplateMutationtypes.CREATE_CONTENT_TREE_TEMPLATE] = function (state, payload) {
        state.content_tree_templates.push(payload);
    },
    _a[ContentTreeTemplateMutationtypes.UPDATE_CONTENT_TREE_TEMPLATE] = function (state, payload) {
        var index = state.content_tree_templates.findIndex(function (temp) { return temp.id === payload.id; });
        if (index >= 0) {
            state.content_tree_templates.splice(index, 1, payload);
        }
    },
    _a[ContentTreeTemplateMutationtypes.DELETE_CONTENT_TREE_TEMPLATE] = function (state, payload) {
        var index = state.content_tree_templates.findIndex(function (temp) { return temp.id === payload; });
        if (index >= 0) {
            state.content_tree_templates.splice(index, 1);
        }
    },
    _a);
export var actions = {
    initState: function (_a) {
        var commit = _a.commit;
        commit(ContentTreeTemplateMutationtypes.INIT_STATE, state());
    },
    fetchContentTreeTemplates: function (_a) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, contentTreeTemplateApiClient.fetchTemplates()];
                    case 1:
                        response = _b.sent();
                        commit(ContentTreeTemplateMutationtypes.FETCH_CONTENT_TREE_TEMPLATES, response.data.content_tree_templates);
                        return [2 /*return*/];
                }
            });
        });
    },
    createContentTreeTemplate: function (_a) {
        var commit = _a.commit, getters = _a.getters;
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        params = {
                            title: "\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8" + (getters.contentTreeTemplates.length + 1),
                            auto_create: false
                        };
                        return [4 /*yield*/, contentTreeTemplateApiClient.create(params)];
                    case 1:
                        response = _b.sent();
                        commit(ContentTreeTemplateMutationtypes.CREATE_CONTENT_TREE_TEMPLATE, response.data.content_tree_template);
                        return [2 /*return*/];
                }
            });
        });
    },
    updateContentTreeTemplate: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, contentTreeTemplateApiClient.update(payload.id, payload.params)];
                    case 1:
                        response = _b.sent();
                        commit(ContentTreeTemplateMutationtypes.UPDATE_CONTENT_TREE_TEMPLATE, response.data.content_tree_template);
                        return [2 /*return*/];
                }
            });
        });
    },
    deleteContentTreeTemplate: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, contentTreeTemplateApiClient.destroy(payload)];
                    case 1:
                        _b.sent();
                        commit(ContentTreeTemplateMutationtypes.DELETE_CONTENT_TREE_TEMPLATE, payload);
                        return [2 /*return*/];
                }
            });
        });
    }
};
